/**
 * @generated SignedSource<<8e74c6afd2d9bd887547fcd015a9e81c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsReviewContainerLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsReviewContainer_viewer">;
  readonly " $fragmentType": "PdpSharedDealerDetailsReviewContainerLazy_viewer";
};
export type PdpSharedDealerDetailsReviewContainerLazy_viewer$key = {
  readonly " $data"?: PdpSharedDealerDetailsReviewContainerLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsReviewContainerLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsReviewContainerLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsReviewContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d77c33f3cb6c0bbfb850e1f992afb4be";

export default node;
